$shm_agent_app_sessions_head $shm_list_head
	search_showed false
	Controls $mol_view
		sub <= controls /
	controls /
